module.exports = __webpack_public_path__ + "img/2.a9b262e7.png";